export const IMPORT_PLATFORMS = [
    'nocodb',
    'baserow',
    'grist',
    'teable',
    'seatable',
    'clickup',
    'asana',
    'notion',
    'monday',
    'smartsheet',
];
//# sourceMappingURL=import-platforms.js.map